import { MyNotifications } from "@/models/MyNotifications";
import Global from "../globals/globals";
import { secureGet, secureSet } from "../utils/secureStorage";
class NotificationController{
    Notifications : MyNotifications[];
constructor(){
    this.Notifications=[];
    if (typeof window !== "undefined") {
        const savedNotifications = secureGet(localStorage, "notifications");
        if (savedNotifications) {
          this.Notifications = JSON.parse(savedNotifications);
        }
      }
}

saveNotificationsToLocalStorage() {
    console.log("Saving notifications to localStorage:", this.Notifications);
    if (typeof window !== "undefined") {
      secureSet(localStorage, "notifications", JSON.stringify(this.Notifications));
      const event = new Event("notificationsUpdate");
      window.dispatchEvent(event);
    }
  }

  addNotification(newNotification: MyNotifications): void {
    this.Notifications.push(newNotification);
    this.saveNotificationsToLocalStorage();
    console.log("Notification list: " + this.Notifications);
  }

  removeNotificationById(notificationId: string): void {
    this.Notifications = this.Notifications.filter((n) => n.id !== notificationId);
    this.saveNotificationsToLocalStorage();
    const event = new Event("notificationsUpdate");
    window.dispatchEvent(event); 
  }


}
export default NotificationController;
